import { FC } from "react";

import { IProposalWithMetaData } from "../../../../../common/interfaces/proposals.interface";

import {
  getProposalStatusBackgroundColorFromSolana,
  getProposalStatusColorFromSolana,
  getProposalStatusText,
} from "../proposals-functions";
import "./ProposalStatusAndLink.scss";

const ProposalStatusAndLink: FC<{
  proposalWithMetadata: IProposalWithMetaData;
}> = ({ proposalWithMetadata }) => {
  return (
    <div className="proposal-status-link">
      <p
        style={{
          color: getProposalStatusColorFromSolana(
            proposalWithMetadata.proposalBasicData.proposalAccount.account
              .state,
            proposalWithMetadata.metadata.proposalAction,
            proposalWithMetadata.metadata.offerStatus,
            proposalWithMetadata.metadata.hasNftSoldOnSolsea
          ),
          background: getProposalStatusBackgroundColorFromSolana(
            proposalWithMetadata.proposalBasicData.proposalAccount.account
              .state,
            proposalWithMetadata.metadata.offerStatus,
            proposalWithMetadata.metadata.proposalAction,
            proposalWithMetadata.metadata.hasNftSoldOnSolsea
          ),
        }}
      >
        {getProposalStatusText(
          proposalWithMetadata.proposalBasicData.proposalAccount.account.state,
          proposalWithMetadata.metadata.offerStatus,
          proposalWithMetadata.metadata.hasNftSoldOnSolsea
        )}
      </p>
    </div>
  );
};

export default ProposalStatusAndLink;
